<p class="uitk-u-margin-top--base"><strong>Search Results</strong> {{currentindex}} of {{totalRecords}}</p>
